<!-- サイドバナー -->
<template>
  <ul class="side_banner1">
    <li v-for="(banner, index) in bannerListData" :key="banner.bannerName">
      <a :href="banner.bannerUrl" target="_blank">
        <span class="banner1">
          <img
            :src="imageSources[index] + '?v=' + new Date().getTime()"
            :alt="banner.bannerName"
            @error="handleImageError(index)"
          />
          <span v-if="imageError[index]" class="t1">{{
            banner.bannerName
          }}</span>
        </span>
        <span class="text1">{{ banner.bannerCaption }}</span>
      </a>
    </li>
  </ul>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { AxiosError } from "axios";
import apiAuthClient from "@/util/apiClientAuth";
import { outputDebugLogs, formatMessage, getTargetDate } from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";

interface Item {
  bannerName: string;
  bannerCaption: string;
  bannerUrl: string;
  bannerImgFileName: string;
}

export default defineComponent({
  name: "SideSliderComponent",
  setup() {
    const bannerListData = ref<Item[]>([]);
    const imageError = ref<boolean[]>([]);
    const imageSources = ref<string[]>([]);

    const handleImageError = (index: number) => {
      imageError.value[index] = true;
      imageSources.value[index] = "/WITH_AG_PORTAL/images/bana-base1.png";
    };

    onMounted(async () => {
      try {
        outputDebugLogs("フリーバナー取得");

        // バナーデータ取得API
        const response = await apiAuthClient.post("/api/Banner/getBannerList", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          bannerKbn: AppConstants.BANNER_KBN_SIDE,
          targetDate: getTargetDate(""),
        });
        bannerListData.value = response.data.bannerListData;
        outputDebugLogs(
          "フリーバナー取得成功 件数：" + bannerListData.value.length
        );

        imageError.value = new Array(bannerListData.value.length).fill(false);
        imageSources.value = bannerListData.value.map(
          (banner) => `/WITH_AG_PORTAL/images/${banner.bannerImgFileName}`
        );
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "フリーバナーデータの取得"));
      } finally {
        //何か入れるかも
      }
    });

    return { bannerListData, imageError, imageSources, handleImageError };
  },
});
</script>
